// paywall.module.ts
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular'; // Import IonicModule
import { PaywallComponent } from './paywall.component'; // Import your PaywallComponent

@NgModule({
  declarations: [PaywallComponent],
  imports: [
    CommonModule,
    IonicModule // Import IonicModule here
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // Add CUSTOM_ELEMENTS_SCHEMA
  exports: [PaywallComponent] // Export the component if used elsewhere
})
export class PaywallModule {}
